<template>
  <div>
    <div class="pb-0 pb-sm-2">
      <h1 class="title title--h1 first-title title__separate">About Me</h1>
      <div class="about-text">
        <p>I'm <strong>Prasham Tated</strong> — a <strong>Senior DevOps Engineer</strong>, <strong>Platform Architect</strong>, and <strong>SRE specialist</strong> with over <strong>{{ yearsOfExperience }} years</strong> of hands-on experience engineering large-scale cloud infrastructure for Fortune 500 enterprises. I hold <strong>CKA, CKAD, and AWS certifications</strong>, and I've been recognized with the <strong>"Transform Collaborate Partner" Award</strong> for delivering a Kubernetes-native GitOps platform that won a new enterprise client and generated <strong>$1M+ in revenue</strong>.</p>

        <p>Throughout my career, I've driven measurable business impact: cutting release cycles by <strong>75%</strong>, achieving <strong>99.9% uptime SLAs</strong> across production clusters, saving <strong>$500K+ annually</strong> through cloud cost optimization, and containerizing <strong>90% of legacy applications</strong> to modern Kubernetes architectures. I've led CI/CD transformations, built IaC platforms across <strong>50+ environments</strong>, and mentored engineering teams on DevSecOps, GitOps, and platform engineering best practices.</p>

        <p>Currently based in <strong>Limassol, Cyprus</strong>, I bring a global perspective from {{ yearsInEurope }}+ years of working across Europe, with production deployments spanning <strong>Europe, Asia, and North America</strong> for clients including <strong>AT&amp;T</strong> and <strong>T-Mobile</strong>. My technical depth covers <strong>AWS, Kubernetes, Terraform, ArgoCD, Jenkins, Prometheus</strong>, and the full cloud-native ecosystem — from infrastructure provisioning to observability to security.</p>

        <p>I'm driven by a relentless pursuit of <strong>engineering excellence</strong> — whether it's architecting zero-downtime deployments, championing shift-left security, or exploring the intersection of <strong>Platform Engineering, FinOps, and MLOps</strong>. If you're looking for someone who doesn't just keep the lights on but transforms how engineering teams ship software — let's talk.</p>
      </div>
    </div>

    <div class="mt-4">
      <h2 class="title title--h3">What I'm Doing</h2>
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="case-item">
            <img :src="require('@/assets/images/devops_sre_b8f5ee29fa.svg')" alt="devops_sre" width="40" height="40">
            <div class="mt-3">
              <h3 class="title title--h4">DevOps &amp; Platform Engineering</h3>
              <p class="case-item__caption">Architecting GitOps-native CI/CD platforms with Jenkins, ArgoCD, and Argo Workflows — delivering 75% faster releases and 40% fewer deployment errors</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="case-item">
            <img :src="require('@/assets/images/cloud_computing_743c36c508.svg')" alt="cloud_computing" width="40" height="40">
            <div class="mt-3">
              <h3 class="title title--h4">Cloud Architecture &amp; FinOps</h3>
              <p class="case-item__caption">Designing multi-cloud infrastructure on AWS and Azure with Terraform IaC, driving 20-35% cost reductions and $500K+ annual savings</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="case-item">
            <img :src="require('@/assets/images/sre_550e1ee575.png')" alt="sre" width="40" height="40">
            <div class="mt-3">
              <h3 class="title title--h4">Site Reliability Engineering</h3>
              <p class="case-item__caption">Maintaining 99.9% uptime SLAs with Prometheus, Grafana, and ELK observability stacks — reducing MTTR by 40% through proactive alerting</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="case-item">
            <img :src="require('@/assets/images/web_dev_d2d448f99d.svg')" alt="web_dev" width="40" height="40">
            <div class="mt-3">
              <h3 class="title title--h4">Kubernetes &amp; Container Orchestration</h3>
              <p class="case-item__caption">Migrating 90% of legacy applications to Kubernetes and OpenShift — achieving 50% better scalability and $150K annual savings</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-4">
      <h2 class="title title--h3">Trusted By</h2>
      <div class="trusted-by">
        <span class="trusted-by__name">AT&amp;T</span>
        <span class="trusted-by__name">T-Mobile</span>
        <span class="trusted-by__name">Amdocs</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutView',
  data() {
    const careerStart = new Date(2012, 2, 1);
    const europeStart = new Date(2018, 4, 1);
    const now = new Date();

    return {
      yearsOfExperience: Math.floor((now - careerStart) / (365.25 * 24 * 60 * 60 * 1000)),
      yearsInEurope: Math.floor((now - europeStart) / (365.25 * 24 * 60 * 60 * 1000))
    };
  }
}
</script>

<style scoped>
.about-text p {
  margin-bottom: 1rem;
  line-height: 1.8;
  color: #b0b0b2;
  font-size: 0.98rem;
}

.about-text p:last-child {
  margin-bottom: 0;
}

.about-text strong {
  color: #f0f0f0;
}

.trusted-by {
  display: flex;
  align-items: center;
  gap: 2.5rem;
  flex-wrap: wrap;
}

.trusted-by__name {
  font-size: 1.2rem;
  font-weight: 600;
  color: #8c8c8e;
}
</style>
